import React, { useState, useEffect } from "react";
import { Grid, Button } from "@material-ui/core";
import AutoInputPaises from "../AutoInputPais";
import AutoInputCuidades from "../AutoInputCiudades";
import { FPaquetesStyle } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import {
  altaDestinosPaqueteAction,
  obtenerDestinosByPaquete,
} from "./../../../ducks/paqueteDuck";
import { ToastMessage } from "../../../global/ToastMessage";
import TablaRegistro from "./TablaRegistro";
import BackDrop from "./../../../global/BackDrop";

const InitialValuePais = {
  IdPais: 0,
  Nombre: "",
  Codigo: "0",
}
const InitialValueCiudad = {
  IdCiudad: 0, 
  Nombre: ""
}

const Destinos = (props) => {
  const { idPaquete = 0 } = props;
  const dispatch = useDispatch();
  const destinosPaquete = useSelector((state) => state.paquetes.arrayDestinos);
  const [pais, setPais] = useState(InitialValuePais);
  const [cuidad, setCuidad] = useState(InitialValueCiudad);
  const classes = FPaquetesStyle();
  const [isLoad, setIsLoad] = useState(false);
  
  useEffect(() => {
    setIsLoad(true);
    dispatch(obtenerDestinosByPaquete(idPaquete)).then((Response) => {
      setIsLoad(false);
    });
  }, [idPaquete, dispatch]);

  const onGuardar = () => {
    if (pais.IdPais > 0 && cuidad.IdCiudad > 0) {
      if (!destinosPaquete.find(destino => destino.IdCiudad === cuidad.IdCiudad)){
        setIsLoad(true);
        let payload = {
          IdPaquete: idPaquete,
          IdCiudad: cuidad.IdCiudad,
        };
        dispatch(altaDestinosPaqueteAction(payload)).then((Response) => {
          switch (Response.status) {
            case 500:
              ToastMessage.fire({
                icon: "error",
                title: "Ha habido un problema de conexión con el servidor",
              });
              break;
            case 400:
              ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
              });
              break;
            default:
              LimpiarForm();
              ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
              });
              break;
          }
          setIsLoad(false);
        });
      } else {
        ToastMessage.fire({
          icon: "warning",
          title: "<strong>Atención</strong>",
          text: "Este destino ya fue agregado.",
        });
      }
    }
  };
  const LimpiarForm = () => {
    setPais(InitialValuePais);
    setCuidad(InitialValueCiudad);
  };
  return (
    <Grid container className={classes.containerSpacing}>
      <Grid item xs={6}>
        <TablaRegistro rows={destinosPaquete} idPaquete={idPaquete} />
      </Grid>
      <Grid item xs={6}>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12}>
            <AutoInputPaises
              label="Pais de origen"
              name="pais"
              target={pais}
              setTarget={setPais}
            />
          </Grid>
          <Grid item xs={12}>
            <AutoInputCuidades
              label="Ciudad de origen"
              name="ciudad"
              target={cuidad}
              setTarget={setCuidad}
              CodigoPais={pais.Codigo}
            />
          </Grid>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              onClick={onGuardar}
              variant="contained"
              color="primary"
              className={classes.modalBoton}
              disabled={cuidad.IdCiudad > 0 ? false : true}
            >
              Agregar
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </Grid>
  );
};
export default Destinos;
